<template>
  <div>
    <div class="subheading grey--text mt-6 ml-4">
      <h5 v-if="receivedSentSMS">
        Sent SMS[{{ receivedSentSMS.totalRecords }}]
      </h5>
    </div>
    <div class="mt-8">
      <template>
        <v-data-table
          v-if="receivedSentSMS"
          :headers="headers"
          :items="receivedSentSMS.sent"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="_id"
          show-expand
          hide-default-footer
        >
          <template v-slot:[`item.cost`]="{ item }">
            <v-chip color="primary" dark>
              {{ item.cost }}
            </v-chip>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | niceDate }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:expanded-item="{ item }">
            <p class="mr-0 ml-2">
              {{ item.message }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <TableMenu :sent="item" />
          </template>
        </v-data-table>
      </template>

      <div class="text-center mt-8">
        <Pagination
          v-if="receivedSentSMS"
          store="sent"
          collection="sent"
          action="fetchSent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import TableMenu from "./menu/SentTableMenu";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: { TableMenu, Pagination },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 2,
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: "Sender ID:",
          align: "start",
          value: "senderId",
        },
        { text: "To", sortable: false, value: "to" },
        { text: "Cost(Ksh)", sortable: false, value: "cost" },
        { text: "Date | Time", sortable: false, value: "createdAt" },
        { text: "Status", sortable: false, value: "status" },
        { text: "Message", value: "data-table-expand" },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  created() {
    this.$store.dispatch("sent/fetchSent", 1);
  },
  computed: {
    receivedSentSMS() {
      return this.$store.getters["sent/sent"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
  methods: {
    getColor(carbs) {
      if (carbs === "Pending") return "orange";
      else if (carbs === "Sent") return "green";
    },
  },
};
</script>
